<template>
  <div class="home">
    <div class="banner"></div>
    <div class="opts main-center">
      <el-form class="form" :inline="true">
        <el-form-item label="城市">
          <el-cascader
            v-model="area"
            :options="areasData"
            :props="areasProps"
            @change="handleAreaChange"
            style="width: 540px"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="门店" style="margin-right: 0">
          <el-input
            v-model="shopName"
            placeholder="请输入门店名称或授权码进行搜索"
            clearable
            style="width: 512px"
            @keyup.enter.native="fetchShops(false)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click.native="fetchShops(false)"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <template v-if="ready">
      <Empty v-if="!shops.length" class="empty" />
      <template v-else>
        <div class="shop-block-list main-center clearfix">
          <ShopBlock v-for="(item, index) in shops" :key="index" v-bind="item" />
        </div>
        <div ref="loadmore" class="loadmore main-center"></div>
        <!-- <div v-if="allLoaded" class="all-loaded main-center">已全部加载完</div> -->
      </template>
    </template>
    <template v-else>
      <div class="skeleton main-center">
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { Form, FormItem, Cascader, Input, Button, Loading } from 'element-ui'
import { getAreasData, getUserCurArea, getShopListPage } from '@/api'
import { areaDataToTwoLevel } from '@/utils'
import ShopBlock from '@/components/ShopBlock'
import Empty from '@/components/Empty'
export default {
  name: 'Home',

  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Cascader.name]: Cascader,
    [Button.name]: Button,
    [Input.name]: Input,
    ShopBlock,
    Empty,
  },

  data() {
    return {
      ready: false,
      shops: [],
      area: [0],
      areasData: [],
      areasProps: {
        value: 'regionId',
        label: 'regionName',
        children: 'child',
        checkStrictly: true
      },
      shopName: '',
      // pageSize: 99999,
      pageSize: 20,
      pageNumber: 1,
      loadingMore: false, // 是否正在加载更多分页数据
      allLoaded: false, // 分页数据是否全部加载完成
    }
  },

  mounted() {
    console.log('🚀 ~.mounted')
    this.fetchAreasData()
    this.fetchCurrentArea().then((area) => {
      return this.fetchShops()
    }).then(() => {
      // 第一次数据加载完成后，开始监听
      this.handleObserve()
    })
  },

  methods: {

    handleObserve() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            /**
             * isIntersecting
             * 0 表示目标元素完全不可见。
             * 1 表示目标元素完全可见。
             * 0~1 表示目标元素部分可见
             */
            console.log('entry', entry)
            if (entry.intersectionRatio >= 0) {
              console.log('进入可视区域')
              this.fetchShops(true)
            } else {
              console.log('不可见')
            }
          })
        },
        {
          threshold: 0,
        }
      )
      observer.observe(this.$refs.loadmore)
    },

    fetchAreasData() {
      getAreasData()
        .then((res) => {
          if (res.data.code === 0) {
            const { regionInfo } = res.data.data
            // this.areasData = areaDataToTwoLevel(regionInfo)
            this.areasData = [
              {
                regionName: '全国',
                regionId: 0,
                child: null,
              },
              ...regionInfo,
            ]
          }
        })
        .catch((err) => {})
    },

    fetchCurrentArea() {
      // const params = {
      //   longitude: '',
      //   latitude: '',
      // }
      // return getUserCurArea(params)
      //   .then((res) => {
      //     if (res.data.code === 0) {
      //       const { defaultRegion } = res.data.data
      //       const proviceId = defaultRegion.regionId
      //       const cityId = defaultRegion.child[0].regionId
      //       const area = (this.area = [proviceId, cityId])
      //       return area
      //     } else {
      //       return Promise.reject(res)
      //     }
      //   })
      //   .catch((err) => Promise.reject(err))
      return Promise.resolve()
    },

    fetchShops(loadmore = false) {
      console.log('🚀 ~.fetchShops ~ loadingMore:', this.loadingMore, loadmore)
      if (this.loadingMore || (loadmore && this.allLoaded)) {
        return Promise.resolve()
      }
      console.log(111)
      if (loadmore) {
        console.log(222)
        this.loadingMore = true
        this.pageNumber++
      } else {
        this.pageNumber = 1
      }
      const params = {
        provinceId: this.area[0] || '',
        cityId: this.area[1] || '',
        districtId: this.area[2] || '',
        longitude: '',
        latitude: '',
        shopName: this.shopName,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
      }
      return getShopListPage(params)
        .then((res) => {
          this.ready = true
          if (res.data.code === 0) {
            const data = res.data.data
            const list = data.list || []
            const totalSize = data.totalSize || 0
            console.log("🚀 ~ .then ~ list:", list)
            this.shops = loadmore ? this.shops.concat(list) : list
            this.allLoaded = this.shops.length >= totalSize
            setTimeout(() => {
              this.loadingMore = false
            }, 200)
            console.log('🚀 ~ .then ~ this.shops:', this.shops)
            // const { c = '' } = this.$route.query
            // if (c) {
            //   this.shops = this.shops.filter((item) => {
            //     return item.shopCategory == c
            //   })
            // }
          }
        })
        .catch((err) => {
          this.ready = true
          this.loadingMore = false
        })
    },

    handleAreaChange(value) {
      console.log(value)
      this.fetchShops()
    },
  },
}
</script>

<style lang="less" scoped>
.home {
  background: #fff;
  .banner {
    min-width: 1274px;
    height: 550px;
    background: url(https://img.xunfei.cn/mall/ifly-mall-members/imgs/bg-banner.jpg)
      center center no-repeat;
  }
  .opts {
    padding: 50px 0 30px;
    text-align: center;
    .form {
      display: flex;
      justify-content: space-between;
    }
  }
  .shop-block-list {
    display: flex;
    flex-wrap: wrap;
    // padding-bottom: 30px;
  }
  .loadmore,
  .all-loaded {
    text-align: center;
    line-height: 50px;
    color: #666;
  }
  .empty {
    margin: 0 auto;
    padding: 30px 0 100px 0;
  }
  .skeleton {
    display: flex;
    .skeleton-item {
      width: 588px;
      height: 234px;
      background: #fafafa;
      border-radius: 4px;
      margin-bottom: 24px;
      &:nth-child(odd) {
        margin-right: 24px;
      }
    }
  }
}
</style>
